const createPickUpTooltip = {
  'Invalid or missing weight value.':
    'https://ayuda.lapmarketplace.com/hc/es-cl/articles/16857945616411',
};

export default createPickUpTooltip;
